import { put, call, take, fork } from 'redux-saga/effects'
import { cardSelectionAddService } from '../../api/card'
import { cardSelectionAddSuccess } from '../../reducers/card/action'
import { CARD_SELECTION_ADD } from '../../reducers/card/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* cardSelectionAddFlow(payload) {
  try {
    const { entity, callback } = payload
    const response = yield call(cardSelectionAddService, entity)

    yield put(cardSelectionAddSuccess(response.data))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* cardSelectionAddWatcher() {
  while (true) {
    const action = yield take(CARD_SELECTION_ADD)
    const { payload } = action

    yield fork(generalSaga, cardSelectionAddFlow, payload, true)
  }
}
